import type { SerializedMeterModel } from '@enmon/commons/lib/tools';
import { Popconfirm, Typography } from 'antd';
import { useAssignModuleToModel } from 'api/hooks/meter-modules/useAssignModule';
import { Button } from 'components';
import { Icon } from 'components/icon';
import { type FC, useCallback } from 'react';
import { useModuleDetailContext } from '../store';

const { Text } = Typography;

interface MeterModuleTableActionsProps {
  model: SerializedMeterModel;
}

export const MeterModuleTableActions: FC<MeterModuleTableActionsProps> = ({ model }) => {
  const { moduleId, module } = useModuleDetailContext();

  // Mutations
  const { mutate: assignModuleToModel, isLoading: isAssigning } = useAssignModuleToModel();

  // Handlers
  const handleAssign = useCallback(() => {
    if (!(module && moduleId)) return;

    assignModuleToModel({
      module,
      modelId: model.id,
      assign: false,
    });
  }, [module, moduleId, assignModuleToModel, model.id]);

  return (
    <Popconfirm
      cancelText="Cancel"
      okText="Confirm"
      title={
        <Text>
          Do you really want to <strong>unassign</strong> this meter model?
        </Text>
      }
      zIndex={99999}
      onConfirm={() => handleAssign()}
    >
      <Button icon={<Icon iconString="unlinkHorizontal" />} loading={isAssigning} type="link">
        Unlink
      </Button>
    </Popconfirm>
  );
};
